import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CancelIcon from '../../../assets/images/cancelIcon.svg';

const PayuFail: React.FC = () => {
  const navigate = useNavigate();
  const [currentDate, setCurrentDate] = useState<string>('');

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/subscription');
    }, 3000);
    return () => clearTimeout(timer);
  }, [navigate]);
  useEffect(() => {
    const date = new Date();
    const formattedDate = date.toLocaleString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit', // 12
      minute: '2-digit', // 34
      hour12: true, // 12-hour format
    });
    setCurrentDate(formattedDate);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#B3B3B394] px-4">
      <div className="bg-white max-w-md w-full rounded-xl shadow-xl p-8 md:p-10 text-center relative overflow-hidden shadow-[#F8F5FF]">
        <div className="flex justify-center mb-2">
          <div className=" p-4 rounded-full">
            <img src={CancelIcon} alt="Cancelled" className="w-9 h-9" />
          </div>
        </div>

        <div className="flex justify-center flex-col items-center">
          <h1 className="text-[#EB897F] font-semibold text-lg mb-2">
            Payment Failed
          </h1>

          <p className="text-[#707070] text-xs mb-4 leading-relaxed w-3/4">
            There was a problem with the card you provided. Please contact your
            card issuer for further assistance.
          </p>
        </div>

        <hr className="border-gray-200 my-3" />

        <div className="text-left space-y-3 mb-8">
          <div>
            <p className="text-[#B7B7B7] text-sm">Status</p>
            <p className="font-semibold text-[#4A4A4A] flex items-center gap-1 text-sm mt-1">
              Cancelled
              <img
                src={CancelIcon}
                alt="Cancelled"
                className="w-3 h-3 inline"
              />
            </p>
          </div>

          <div>
            <p className="text-[#B7B7B7] text-sm">Date</p>
            <p className="font-semibold text-[#4A4A4A] text-xs mt-1">
              {currentDate}
            </p>
          </div>

          <div>
            <p className="text-[#B7B7B7] text-sm">Transaction No.</p>
            <p className="text-[#4A4A4A] text-xs mt-1">Back to Merchant</p>
            <p className="text-[#4A4A4A] text-xs">
              You will be redirected to the subscription page after 3s.
            </p>
          </div>
        </div>

        <button
          onClick={() => navigate('/subscription')}
          className="w-full bg-gradient-to-r from-[#6E3EF5] to-[#8E5CFF] text-white py-3 rounded-xl font-semibold transition hover:opacity-90"
        >
          Back to subscription Page
        </button>
      </div>
    </div>
  );
};

export default PayuFail;
